import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const truncate = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  max-width: inherit; /* Firefox fix, otherwise the text is not ellipsed */
  gap: ${({ $dense }) => ($dense ? pxToRem(2) : '0')} 0;
  text-decoration: none;

  .tct-text {
    font-family: ${theme.fontFamily.default};
    font-weight: ${theme.fontWeight.regular};
    font-style: ${theme.fontStyle.normal};
    line-height: ${theme.lineHeight.neutralized};
    ${truncate}
  }

  .tct-primary {
    font-size: ${theme.fontSize.small};
    color: ${theme.semantic.foreground.primary};
  }

  .tct-secondary {
    font-size: ${theme.fontSize.tiny};
    color: ${theme.semantic.text[100]};
  }
`;
